import {Flex} from "@FRAMEWORK/ui/desktop/layout";
import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import EventImage from "@PUBLIC/P/images/content/event/yellowpangdeal/img_yellow_sprite.png";
import LiveImage from "@PUBLIC/P/images/content/event/yellowlive/img_live_sprite.png";

const TopTitle = styled.h4`
	font-family: "PT-medium";
	font-size: 26px;
	color: var(--emp-color);
`;

const TopPriceBox = styled.div`
	display: flex;
	margin: 14px 0 20px;
	font-size: var(--basic-size);
	line-height: 1;

	> div {
		em {
			font-size: 20px;
			color: var(--red-color);
		}

		> span {
			margin-left: 5px;
			margin-right: 3px;
			font-family: "PT-medium";
		}
		+ div {
			position: relative;
			padding-left: 10px;
			margin-left: 10px;
			line-height: 1;
			&::after {
				position: absolute;
				top: 5px;
				left: 0;
				width: 1px;
				height: 12px;
				background-color: var(--line-color);
				content: "";
			}
		}
	}

	em {
		font-family: "PT-medium";
		font-size: 20px;
		color: var(--emp-color);
	}
`;

const SummaryInfo = styled(Flex)`
	margin-bottom: 12px;
`;

const TagSquareWrap = styled(Flex)`
	width: 1000px;
	flex-wrap: wrap;
`;

const Grade = styled.em`
	margin-left: 11px;
	color: var(--emp-color);
`;

const Schedule = styled.div`
	position: relative;
	display: flex;
	width: 1200px;
	margin: 0 auto;
	gap: 30px;
`;

const ScheduleTitle = styled.div`
	display: flex;
	padding: 20px 0;
	align-items: center;
	justify-content: space-between;
	line-height: 1;

	h5 {
		font-family: "PT-medium";
		font-size: 18px;
		color: var(--emp-color);
	}
`;

const ReservationBox = styled.div`
	display: flex;
	align-items: center;
	gap: 15px;
`;

const ReservationText = styled.span<{state: string}>`
	display: flex;
	font-size: var(--basic-size);
	color: var(--emp-color);
	align-items: center;
	gap: 6px;

	&:before {
		display: inline-block;
		width: 10px;
		height: 10px;
		background-color: ${props => {
			if (props.state === "possible") {
				return `
				var(--yellow-color);
			`;
			}
			if (props.state === "waiting") {
				return `
				#bfd1f5;
			`;
			}
			if (props.state === "deadline") {
				return `
				var(--line-color);
			`;
			}
		}};
		content: "";
	}
`;

const ScheduleWrap = styled.div`
	position: relative;
	width: 770px;
`;

const FilterTagContainer = styled.div`
	display: flex;
	padding: 20px;
	margin-bottom: 20px;
	align-items: center;
	border: 1px solid var(--line-color);
	gap: 20px;
	align-items: start;

	li {
		display: inline;
	}
`;

const FilterTitle = styled.span`
	display: inline-flex;
	height: 30px;
	margin-right: 48px;
	font-size: 16px;
	gap: 9px;
	align-items: center;
	flex-shrink: 0;

	&:before {
		display: inline-block;
		width: 15px;
		height: 15px;
		background: url(${SpriteImage}) -222px 0 / 400px 400px;
		content: "";
	}
`;

const FilterTagBox = styled.ul`
	display: flex;
	gap: 6px;
	flex-wrap: wrap;

	li {
		display: inline-flex;
		align-items: center;
	}
`;

const FilterTag = styled.span`
	display: inline-flex;
	height: 30px;
	padding: 0 10px;
	border-radius: 3px;
	background-color: #f3f3f3;
	font-size: var(--basic-size);
	align-items: center;
`;

const FilterTagDeleteButton = styled.button`
	display: block;
	position: relative;
	width: 12px;
	height: 12px;
	margin-left: 5px;
	margin-top: 1px;
	background-color: transparent;
	font-size: 0;

	&::before,
	&::after {
		position: absolute;
		top: 50%;
		left: 0;
		right: 0;
		height: 1px;
		background: #7c7c7c;
		transform: translateY(-50%);
		content: "";
	}

	&::before {
		transform: rotate(45deg);
	}

	&::after {
		transform: rotate(-45deg);
	}
`;
const ResetButton = styled.button`
	margin-right: 14px;
	background-color: transparent;
	font-size: var(--basic-size);
	color: var(--gray-color);
`;

const CheckBox = styled.div`
	padding: 10px 0;
	ul {
		grid-gap: 10px 0;

		li {
			display: flex;
			align-items: center;
			gap: 10px;
			outline: none;

			label {
				text-align: left;
			}
		}
	}
`;

const FilterCheckWrap = styled.div`
	border-left: 1px solid var(--line-color);
	border-right: 1px solid var(--line-color);
`;

const PromotionWrap = styled.div`
	margin-top: 20px;
`;

const PromotionList = styled.ul`
	li {
		border-top: 1px solid var(--line-color);

		> a {
			display: block;
			padding: 20px;

			&:hover {
				background-color: #f2f2f2;
			}
		}
	}
`;

const PromotionDate = styled.div`
	display: flex;
	justify-content: space-between;
	div:first-of-type {
		span:not(:first-of-type) {
			margin-left: 15px;

			&:before {
				display: inline-block;
				width: 1px;
				height: 12px;
				margin-right: 15px;
				background-color: var(--line-color);
				content: "";
			}
		}
	}
`;

const PromotionTitle = styled.p`
	margin-top: 10px;
	color: var(--emp-color);
	letter-spacing: 0;
`;

const PromotionOption = styled.p`
	margin-top: 10px;
	font-size: var(--basic-size);
	color: var(--gray-color);

	span {
		margin-right: 5px;
		color: var(--default-color);
	}
`;

const PromotionPrice = styled.div`
	display: flex;
	margin-top: 15px;
	justify-content: end;
	align-items: center;
	line-height: 1;
`;

const SeatsAvailable = styled.span`
	margin-right: 10px;
	font-size: 13px;
`;

const Status = styled.span<{state: string}>`
	margin-right: 20px;
	font-family: "PT-medium";

	color: ${props => {
		if (props.state === "possible") {
			return `
			#ffae00;
		`;
		}
		if (props.state === "waiting") {
			return `
			#a1baec;
		`;
		}
		if (props.state === "deadline") {
			return `
			#bbb;
		`;
		}
	}};
`;

const Price = styled.span`
	font-family: "PT-medium";
	color: var(--red-color);

	em {
		font-size: var(--medium-size);
	}
`;

const CalendarControl = styled.div`
	display: flex;
	padding: 40px 0;
	border-top: 1px solid var(--line-color);
	gap: 40px;
	align-items: center;
	justify-content: center;

	span {
		font-size: 22px;
		font-family: "PT-medium";
		color: var(--emp-color);
	}
`;

const CalendarButton = styled.button<{month: string}>`
	display: inline-flex;
	width: 110px;
	height: 38px;
	border: 1px solid var(--bl-color);
	background-color: #fff;
	color: var(--emp-color);
	font-family: "PT-regular";
	align-items: center;
	justify-content: center;

	em {
		position: relative;
		&:before {
			position: absolute;
			top: 5px;
			display: block;
			width: 7px;
			height: 7px;
			border-left: 1px solid var(--emp-color);
			border-bottom: 1px solid var(--emp-color);
			background-color: transparent;
			content: "";
		}
	}

	&[type="button"]:disabled {
		border-color: #e1e1e1;
		color: #a9a9a9;
		cursor: unset;
		em {
			&:before {
				border-left: 1px solid #a9a9a9;
				border-bottom: 1px solid #a9a9a9;
			}
		}
	}

	${props => {
		if (props.month === "prev") {
			return `
			em {
				padding-left: 15px;
				padding-right: 0;
				&:before {
					left: 2px;
					transform: rotate(45deg);
				}
			}
			
			`;
		}
		if (props.month === "next") {
			return `
			em {
				padding-right: 15px;
				&:before {
					right: 2px;
					transform: rotate(-135deg);
				}
			}
			`;
		}
	}}
`;

const EmptyBox = styled.div`
	display: flex;
	padding: 40px 0;
	flex-direction: column;
	gap: 10px;
	align-items: center;
	line-height: 1;

	a {
		position: relative;
		padding: 0 16px 1px 0;
		color: var(--emp-color);
		border-bottom: 1px solid var(--emp-color);

		&:after {
			position: absolute;
			top: 5px;
			right: 2px;
			display: block;
			width: 7px;
			height: 7px;
			border-left: 1px solid var(--emp-color);
			border-bottom: 1px solid var(--emp-color);
			background-color: transparent;
			transform: rotate(-135deg);
			content: "";
		}
	}
`;

const BenefitButton = styled.button`
	position: absolute;
	bottom: 15px;
	right: 15px;
	width: 28px;
	height: 28px;
	border: 1px solid var(--bl-color);
	background: #fff;
	cursor: pointer;
	z-index: 1;

	&:before,
	&:after {
		position: absolute;
		top: 50%;
		left: 50%;
		display: block;
		background-color: var(--emp-color);
		transform: translate(-50%, -50%);
		content: "";
	}
	:after {
		width: 10px;
		height: 2px;
	}

	:before {
		width: 2px;
		height: 10px;
	}
`;

const OptionCheckList = styled.div<{show?: boolean}>`
	overflow: hidden;
	max-height: 92px;

	${props =>
		props.show &&
		`
			max-height: none;
		`}
`;

const ScrollHeightBox = styled.div`
	position: relative;
	width: 100%;
	min-height: 560px;
	> div {
		width: 770px;
	}
`;

const EventBanner = styled.div`
	margin-top: 20px;

	img {
		max-width: 100%;
		height: 80px;
		vertical-align: top;
	}
`;

const BannerYellowpangdeal = styled.div`
	position: relative;
	display: flex;
	margin: 20px 0;
	justify-content: end;

	&:before {
		position: absolute;
		left: 0;
		display: block;
		width: 80%;
		height: 100%;
		background: linear-gradient(to top, #ffde2f 58px, #fff 17px);
		content: "";
	}

	a {
		display: flex;
		z-index: 1;
		align-items: end;
	}
`;

const PangdealPrice = styled.div`
	width: 915px;
	height: 79px;
	background: url(${EventImage}) 0px -450px/ 1200px 600px no-repeat;
`;

const PangdealText = styled.div`
	display: flex;
	height: 58px;
	padding-left: 285px;
	margin-top: 22px;
	color: #222;
	font-size: 20px;
	align-items: center;
	gap: 30px;

	p {
		position: relative;
		line-height: 1;
		color: var(--emp-color);

		&:not(:first-child)::before {
			position: absolute;
			left: -15px;
			top: 50%;
			width: 1px;
			height: 14px;
			background-color: #bbb;
			transform: translateY(-50%);
			content: "";
		}
	}
`;

const PangdealProduct = styled.span`
	font-family: "PT-medium";
	color: var(--red-color);
`;

const PangdealDate = styled.span`
	font-family: "PT-medium";
	color: var(--blue-color);
`;

const PangdealLink = styled.div`
	position: relative;
	display: flex;
	height: 58px;
	width: 184px;
	background-color: #ffc72c;
	color: #222;
	font-size: 14px;
	line-height: 1.42;
	align-items: center;

	span {
		position: absolute;
		left: 50%;
		padding-right: 17px;
		transform: translateX(-50%);

		&:after {
			position: absolute;
			right: 0px;
			bottom: 2px;
			width: 7px;
			height: 7px;
			border-top: 1px solid #333;
			border-left: 1px solid #333;
			transform: translate(-50%, -50%) rotate(135deg);
			content: "";
		}
	}
`;

const BannerYellowLive = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	height: 80px;
	margin: 20px 0 40px;
	background-color: #ff9574;

	&:before {
		position: absolute;
		left: 0;
		display: block;
		width: 100%;
		height: 100%;
		background: url(${LiveImage}) 0px -155px/ 1200px 600px no-repeat;
		content: "";
	}
	&::after {
		position: absolute;
		right: 0;
		bottom: 0;
		display: block;
		width: 103px;
		height: 100%;
		background: url(${LiveImage}) 0px 0px/ 1200px 600px no-repeat;
		content: "";
	}
	a {
		display: flex;
		z-index: 1;
		align-items: center;
		width: 100%;
		height: 100%;
		padding-left: 335px;
	}
`;

const LiveText = styled.p`
	display: flex;
	flex: 1 1 100%;
	align-items: center;
	line-height: 1;
`;

const LiveTit = styled.span`
	margin-right: 40px;
	font-size: 20px;
	color: #fff;
`;

const LiveDate = styled.span`
	margin-right: 10px;
	font-size: 22px;
	color: var(--emp-color);
	font-family: "PT-bold";
`;

const LiveState = styled.span`
	font-size: 20px;
	color: #fff;
	font-family: "PT-medium";
`;

const LiveLink = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex: 0 0 auto;
	height: 80px;
	margin-right: 71px;
	font-size: var(--default-size);
	color: var(--emp-color);

	span {
		position: relative;
		line-height: 1;
		&:after {
			position: absolute;
			top: 50%;
			right: -11px;
			width: 6px;
			height: 6px;
			border-top: 1px solid var(--emp-color);
			border-left: 1px solid var(--emp-color);
			transform: translateY(-50%) rotate(135deg);
			content: "";
		}
	}
`;

const FixedScheduleWrap = styled.div`
	position: sticky;
	top: -40px;
	width: 400px;
	height: 560px;
	z-index: 1;
`;

const Airline = styled.span`
	line-height: 1;
`;

const ContentTop = styled.div`
	width: 1200px;
	margin: 0 auto;
`;

const ContentBottom = styled.div`
	width: 100%;
`;

const ContentWrap = styled.div`
	height: 100%;
	padding: 40px 0 40px;
	overflow-y: auto;
`;

const CouponBox = styled.div`
	display: flex;
	justify-content: end;
	padding: 0 2px;
	font-size: var(--basic-size);
	color: var(--emp-color);
	line-height: 1;
	align-items: center;
	gap: 10px;
`;

const CouponIcon = styled.span`
	display: flex;
	align-items: center;

	i {
		display: flex;
		height: 18px;
		padding: 0 4px;
		font-size: 10px;
		color: var(--emp-color);
		font-style: normal;
		border-top: 1px solid #d6d6d6;
		border-bottom: 1px solid #d6d6d6;
		background-color: #fff;
		align-items: center;
	}

	&:before {
		display: block;
		width: 3px;
		height: 20px;
		background: url(${SpriteImage}) -62px 0 / 400px 400px;
		content: "";
	}

	&:after {
		display: block;
		width: 7px;
		height: 20px;
		background: url(${SpriteImage}) -66px 0 / 400px 400px;
		content: "";
	}
`;

export {
	TopTitle,
	TopPriceBox,
	SummaryInfo,
	TagSquareWrap,
	Grade,
	Schedule,
	ScheduleTitle,
	ReservationBox,
	ReservationText,
	ScheduleWrap,
	FilterTagContainer,
	FilterTitle,
	FilterTagBox,
	FilterTag,
	FilterTagDeleteButton,
	ResetButton,
	CheckBox,
	FilterCheckWrap,
	PromotionWrap,
	PromotionList,
	PromotionDate,
	PromotionTitle,
	PromotionOption,
	PromotionPrice,
	SeatsAvailable,
	Status,
	Price,
	CalendarControl,
	CalendarButton,
	EmptyBox,
	BenefitButton,
	OptionCheckList,
	ScrollHeightBox,
	EventBanner,
	BannerYellowpangdeal,
	PangdealPrice,
	PangdealText,
	PangdealProduct,
	PangdealDate,
	PangdealLink,
	FixedScheduleWrap,
	Airline,
	ContentTop,
	ContentBottom,
	ContentWrap,
	CouponBox,
	CouponIcon,
	BannerYellowLive,
	LiveDate,
	LiveLink,
	LiveState,
	LiveText,
	LiveTit,
};
